export default __webpack_public_path__ + "static/media/4.1 Diba Agenda.5185dc34.png";